import { IBusBaoCaoDiemDanhRequest, IBusTuyenDuongSelectRequest } from "../../../models/request/bus/busBaoCaoDiemDanhRequest";
import { BusBaoCaoDiemDanhItemResponse } from "../../../models/response/bus/BusBaoCaoDiemDanhItemResponse";
import { BusTuyenDuongItemResponse } from "../../../models/response/bus/bus_tuyenduong";
import {
	eBusBaoCaoDiemDanhActionTypeIds,
	IBusBaoCaoDiemDanhLoadErr,
	IBusBaoCaoDiemDanhLoadStart,
	IBusBaoCaoDiemDanhLoadSuccess,
	IBusBaoCaoDiemDanhLoadTuyenDuongErr,
	IBusBaoCaoDiemDanhLoadTuyenDuongStart,
	IBusBaoCaoDiemDanhLoadTuyenDuongSuccess
} from "../../action-types/bus/IBusBaoCaoDiemDanhActionTypes";

export const busBaoCaoDiemDanhActions = {
	loadBusBaoCaoDiemDanhStart: (request: IBusBaoCaoDiemDanhRequest): IBusBaoCaoDiemDanhLoadStart => {
		return {
			type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadBusBaoCaoDiemDanhSuccess: (data: BusBaoCaoDiemDanhItemResponse[]): IBusBaoCaoDiemDanhLoadSuccess => {
		return {
			type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusBaoCaoDiemDanhError: (message: string): IBusBaoCaoDiemDanhLoadErr => {
		return {
			type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadBusTuyenDuongStart: (request: IBusTuyenDuongSelectRequest): IBusBaoCaoDiemDanhLoadTuyenDuongStart => {
		return {
			type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_START,
			payload: request
		}
	},
	loadBusTuyenDuongSuccess: (data: BusTuyenDuongItemResponse[]): IBusBaoCaoDiemDanhLoadTuyenDuongSuccess => {
		return {
			type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_SUCCESS,
			payload: data
		}
	},
	loadBusTuyenDuongError: (message: string): IBusBaoCaoDiemDanhLoadTuyenDuongErr => {
		return {
			type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_ERROR,
			payload: message
		}
	}
}
